export { default } from './GraphLegend';
